<template>
  <div class="purchaseManage-content">
    <banner clazz="purchaseManage-banner" url="purchaseManage">
      <template slot="buttons">
        <el-button class="banner-button" round @click.native="goMore('caigouxunyuan-banner-tiyan')">申请体验</el-button>
        <el-button class="banner-button" round @click="goConsult">立即咨询</el-button>
      </template>
    </banner>
    <div class="purchaseManage-section1 tc">
      <h1 class="section1-title">电子化采购寻源：打造企业高效透明寻源平台</h1>
      <div class="section1-divider dib"></div>
      <div class="section1-content">
        <h1 class="content-header">从采购需求端驱动企业采购降本增效，满足不同品类对寻源模式的差异化需求</h1>
        <div class="content-main">
          <div class="contentBox first tc dib">
            <img class="icon" src="../../assets/img/purchaseManage/platform-1@2x.png" alt="对接ERP，OA等系统<"/>
            <p class="text">对接ERP，OA等系统<br/>收集采购寻源需求</p>
          </div>
          <div class="contentBox second tc dib">
            <img class="icon" src="../../assets/img/purchaseManage/platform-2@2x.png" alt="制定招投标计划或咨询报价策略"/>
            <p class="text">制定招投标计划或<br/>询报价策略</p>
          </div>
          <div class="contentBox third tc dib">
            <img class="icon" src="../../assets/img/purchaseManage/platform-3@2x.png" alt="寻源发布，潜在供应商的寻找与认证"/>
            <p class="text">寻源发布，潜在供应商<br/>的寻找与认证</p>
          </div>
          <div class="contentBox fourth tc dib">
            <img class="icon" src="../../assets/img/purchaseManage/platform-4@2x.png" alt="供应商合作关系建立过程中的谈判与审核"/>
            <p class="text">供应商合作关系建立<br/>过程中的谈判与审核</p>
          </div>
          <div class="contentBox fifth tc dib">
            <img class="icon" src="../../assets/img/purchaseManage/platform-5@2x.png" alt="供应选定与合同签署"/>
            <p class="text">供应选定与合同<br/>签署</p>
          </div>
        </div>
        <p class="content-footer">采购寻源管理平台为企业实现从需求提交与收集、供应商开发、采购招标、询比价、竞价、合同管理等全流程透明化、电子化过程管理。</p>
        <div class="content-button">
          <el-button class="detail-info" round @click.native="goMore('caigouxunyuan-pingtai-xiangqing')">获取详情介绍
          </el-button>
          <el-button class="consult-now" round @click="goConsult">立即咨询</el-button>
        </div>
      </div>
    </div>
    <div class="purchaseManage-section2 tc">
      <h1 class="section2-title">管理谈判过程，加速决标，成本节约</h1>
      <div class="section2-divider dib"></div>
      <h1 class="section2-subtitle">实施科学管控寻源，执行多供应商在线谈判，结合竞价，比价工具，达到降本增效</h1>
      <div class="section2-main">
        <div class="section2-choose dib">
          <div class="left-list">
            <div class="choice" @mouseenter="chooseTab(item.order)"
                 v-for="item in collpaseItem"
                 :class="choice === item.order ? 'is-choosed ' + item.order : item.order">
              <div class="choice-content">
                <div class="icon-container dib">
                  <img class="icon" v-lazy="item.icon" :alt="item.text">
                </div>
                <p class="text">{{item.text}}</p>
              </div>
              <div class="triangle"></div>
            </div>
          </div>
          <div class="right-content">
            <div :class="item.order + '-content'" v-show="choice === item.order" v-for="item in collpaseItem"
                 :key="item.order">
              <h2 class="title">{{item.subtitle}}</h2>
              <div class="text">
                <p v-for="subitem in item.content">{{subitem}}</p>
              </div>
              <img class="image" :url="item.url" v-lazy="item.url" :alt="item.text"/>
            </div>
          </div>
        </div>
      </div>
      <el-button class="consult-button" @click.native="goMore('caigouxunyuan-guocheng-shiyong')">立即试用</el-button>
      <h1 class="section2-title">采购寻源平台价值</h1>
      <div class="section2-divider dib"></div>
      <div>
        <div class="section2-platformValue dib">
          <ul class="platformValue-list">
            <li class="list-item" v-for="item in platformValueList">
              <h2 class="dib block tc">{{item.title}}</h2>
              <div class="list-item-cont">
                <div class="cont-item tc" v-for="subItem3 in item.content">{{subItem3}}</div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <el-button class="consult-button" @click="this.goConsult">立即咨询</el-button>
      <h1 class="section2-title">他们为什么使用甄云寻源系统？</h1>
      <div class="section2-divider dib"></div>
      <div>
        <div class="section2-systemlist tl dib">
          <span class="expand-content dib">
            <div class="expandItem tc dib" :class="index === 0 ? 'expand' : ''" @mouseenter="listExpandOn(index)"
                 @mouseleave="listExpandOff"
                 @touchstart="listExpandOn(index)" @touchend="listExpandOn(index)"
                 :style="{'backgroundImage': item.caig_img ? 'url(' + $global.globalPath + item.caig_img + ')' : ''}"
                 v-for="(item, index) in expandItemList">
              <div class="expandItemMask">
                <img class="expandItemIcon" v-lazy="$global.globalPath + item.caig_logo" :alt="item.title"/>
                <div class="expandItemTextContainer">
                  <p class="expandItemText dib textContent tl">{{index === 0 ? item.caig_describe : item.title}}</p>
                  <p class="expandItemText textFooter tl">{{item.origin ? '— — ' + item.caig_seo : ''}}</p>
                  <p class="expandShowDetail tc" @click="goClientDetail(item.id, item.status)">了解案例详情 ></p>
                </div>
              </div>
            </div>
          </span>
          <div class="expandItem static tc dib" @click="listMove">
            <img class="expandItemIcon" src="../../assets/img/purchaseManage/arrow@2x.png" alt="他们为什么使用甄云寻源系统"/>
          </div>
        </div>
      </div>
      <el-button class="get-detail" @click.native="goMoreCase">获取更多案例</el-button>
    </div>
  </div>
</template>
<script>
import hoverButton from '../common/hoverButton.vue'
import banner from '../common/banner.vue'
import * as className from '../../assets/js/dom'

export default {
  inject: ['openRegister', 'goConsult'],
  name: 'PurchaseManage',
  metaInfo () {
    return {
      title: this.$seo.purchasemanage.title, // set a title
      meta: [{ // set meta
        name: 'keywords',
        content: this.$seo.purchasemanage.keywords
      },
      {
        name: 'description',
        content: this.$seo.purchasemanage.description
      }]
    }
  },
  data () {
    return {
      activeName: 0,
      choice: 'first',
      collpaseItem: [
        {
          order: 'first',
          text: '1. 建设标准的采购需求',
          subtitle: '对接企业内部ERP，OA等信息系统，收集各部门采购需求，将采购流程按照品类、使用部门等企业个性化需求固定下来，实现采购标准化',
          url: require('../../assets/img/purchaseManage/1-peitu-1.png'),
          icon: require('../../assets/img/purchaseManage/icon-1.png'),
          content: []
        },
        {
          order: 'second',
          text: '2. 管理供应商谈判',
          subtitle: '保存历史操作等内容以便审查，建立业务全程监控，保证合规高效',
          url: require('../../assets/img/purchaseManage/2-peitu-1.png'),
          icon: require('../../assets/img/purchaseManage/icon-2.png'),
          content: ['利用引导式导航、谈判模板和直观的工具简化文档创作',
            '建立规范化谈判流程，保持寻源活动之间的流程一致性',
            '通过社交协作，改善沟通和信息共享',
            '通过项目式管理和采购标准流程，实现过程监控，保证合规']
        },
        {
          order: 'third',
          text: '3. 加速决标和节省成本',
          subtitle: '甄云寻源系统帮您缩短采购寻源周期，促进供应商竞争并制定明智的决标决策',
          url: require('../../assets/img/purchaseManage/3-peitu-1.png'),
          icon: require('../../assets/img/purchaseManage/icon-3.png'),
          content: ['实时洞察供应商准入，报价，比价过程',
            '按照不同的条件评估多个投标书',
            '通过可视化图表数据，快速做出正确决策，降低采购成本']
        },
        {
          order: 'fourth',
          text: '4. 建设企业采购寻源实践和知识库',
          subtitle: '通过流程梳理和采购分析，积累采购业务、产品或服务、市场供应方面的经验，以支持企业采购业务不断革新',
          url: require('../../assets/img/purchaseManage/4-peitu-1.png'),
          icon: require('../../assets/img/purchaseManage/icon-4.png'),
          content: []
        }
      ],
      platformValueListLen: 3,
      platformValueList: [
        {
          title: '海量供应货源，智能匹配需求',
          content: [
            '拥有供应商池，对接多家知名商城，提供海量货源',
            '物料品类智能匹配，为客户提供潜在货源智能推荐',
            '助力被动寻源到主动寻源的变革']
        },
        {
          title: '智能分析，全局把控',
          content: [
            '可视化数据报表，支持寻源过程每一个决策点',
            '嵌入风险雷达监控，实时为决策提供全方位支持',
            '用数据支持企业寻源决策']
        },
        {
          title: '多种寻源方式，阳光降本',
          content: [
            '支持常规询比价、竞价、招投标等多种模式寻源',
            '支持对接大宗商品物资价格平台，价格波动实时预警',
            '助力寻源方式从线下到线上的变革']
        }
      ],
      expandItemList: [
        {
          id: '1',
          status: '0',
          title: '加载中',
          caig_describe: '当您看到这则信息，请检查网络链接',
          caig_img: '',
          caig_logo: '',
          caig_seo: ''
        },
        {
          id: '2',
          status: '0',
          title: '加载中',
          caig_describe: '当您看到这则信息，请检查网络链接',
          caig_img: '',
          caig_logo: '',
          caig_seo: ''
        },
        {
          id: '3',
          status: '0',
          title: '加载中',
          caig_describe: '当您看到这则信息，请检查网络链接',
          caig_img: '',
          caig_logo: '',
          caig_seo: ''
        },
        {
          id: '4',
          status: '0',
          title: '加载中',
          caig_describe: '当您看到这则信息，请检查网络链接',
          caig_img: '',
          caig_logo: '',
          caig_seo: ''
        }
      ],
      moveList: true,
      expandController: 0
    }
  },
  components: {
    hoverButton,
    banner
  },
  methods: {
    goMore (code) {
      this.openRegister(false, code)
    },
    // 更多案例
    goMoreCase () {
      window.open('/clientele', '_blank')
    },
    listMove (event) {
      if (this.expandItemList.length <= 4) {
        return false
      }
      let content = document.getElementsByClassName('expandItem')
      let dom = document.getElementsByClassName('static')[0]
      let evt = window.event || event
      if (this.$func.getCurrentBrowser() === 'IE9') {
        evt.cancelBubble = true // 阻止IE冒泡
      } else {
        evt.stopPropagation() // 阻止通用浏览器冒泡
      }
      let list = document.getElementsByClassName('expand-content')
      if (this.moveList) {
        className.addClass(dom, 'is-actived')
        className.addClass(list[0], 'is-moved')
        // 减去的5中包括 展示用的4个item和导航键头的1个static
        list[0].style.right = 175 * (content.length - 5) + 'px'
        let res = (content.length - 1) % 4 ? (content.length - 1) % 4 : 4
        if (this.currentExpand() < res) {
          this.listExpand(res)
        }
      } else {
        className.removeClass(dom, 'is-actived')
        className.removeClass(list[0], 'is-moved')
        list[0].style.right = ''
        if (this.currentExpand() > 3) {
          this.listExpand(0)
        }
      }
      this.moveList = !this.moveList
    },
    currentExpand () {
      let dom = document.getElementsByClassName('expandItem')
      for (let i = 0; i < dom.length - 1; i++) {
        if (className.hasClass(dom[i], 'expand')) {
          return i
        }
      }
      return 0
    },
    listExpandOn (index) {
      this.expandController = setTimeout(() => {
        this.listExpand(index)
      }, 100)
    },
    listExpandOff () {
      clearTimeout(this.expandController)
    },
    listExpand (index) {
      let dom = document.getElementsByClassName('expandItem')
      for (let i = 0; i < dom.length - 1; i++) {
        let contentDom = dom[i].getElementsByClassName('textContent')[0]
        //          let imgDom = dom[i].getElementsByClassName('expandItemIcon')[0]
        if (i !== index) {
          className.removeClass(dom[i], 'expand')
          contentDom.innerText = this.expandItemList[i].title
          //            imgDom.src = this.$global.globalPath + this.expandItemList[i].src
        } else {
          className.addClass(dom[i], 'expand')
          contentDom.innerText = this.expandItemList[i].caig_describe
        }
      }
      //        let imgDom = dom[index].getElementsByClassName('expandItemIcon')[0]
      //        imgDom.src = this.$global.globalPath + this.expandItemList[index].img
    },
    goClientDetail (id, status) {
      // let routeUrl = this.$router.resolve({
      //   name: 'ClienteleDetile',
      //   query: {
      //     id: id
      //   }
      // })
      // if (status === '0') {
      //   window.open(routeUrl.href, '_self')
      // } else if (status === '1') {
      //   window.open(routeUrl.href, '_blank')
      // }
      if (status === '0') {
        let routeObj = this.$router.resolve({
          name: 'ClienteleDetile',
          query: {
            id: id
          }
        })
        window.open(routeObj.href, '_blank')
      } else if (status === '1') {
        this.$api.post('/cases/twenty_four_hour', '', (r) => {
          if (r.code === 0) {
            if (r.data === 1) {
              let routeObj = this.$router.resolve({
                name: 'ClienteleDetile',
                query: {
                  id: id
                }
              })
              window.open(routeObj.href, '_blank')
            } else {
              this.openRegister(false, 'caigouxunyuan-xiangqing')
            }
          } else {
            this.$message.error(r.message)
          }
        })
      } else {

      }
    },
    getExpandData () {
      this.$api.post('/cases/get_cases', { webname: 'purchaseManage', cases_sum: '' }, (r) => {
        this.expandItemList = r.data
        if (this.expandItemList.length > 8) {
          this.expandItemList = this.expandItemList.slice(0, 8)
        }
      })
    },
    chooseTab (str) {
      this.choice = str
    }
  },
  created () {
    this.getExpandData()
  },
  mounted () {
    let array1 = []
    this.platformValueList.forEach((item) => {
      array1.push(item.content.length)
    })
    this.platformValueListLen = Math.max.apply(null, array1)
  }
}
</script>
<style lang="scss">
  @import "../../../static/css/purchaseManage.scss";
</style>



// WEBPACK FOOTER //
// purchaseManage.vue?16f3f199